import { lazy } from "react"
import { Navigate } from "react-router-dom"
import PermissionRoute from "../permission-route"

const InventoryReport = lazy(() => import("src/modules/reports-analytics/pages/inventory-report"))
const DashboardsList = lazy(() => import("src/modules/reports-analytics/report-builder/pages/dashboards-list"))
const DashboardView = lazy(() => import("src/modules/reports-analytics/report-builder/pages/dashboard-view"))
const ReportsList = lazy(() => import("src/modules/reports-analytics/report-builder/pages/reports-list"))
const ReportViewer = lazy(() => import("src/modules/reports-analytics/report-builder/pages/report-viewer"))
const ReportBuilder = lazy(() => import("src/modules/reports-analytics/report-builder/pages/report-builder"))
const SqlReport = lazy(() => import("src/modules/reports-analytics/report-builder/pages/sql-report"))
const TargetBuilder = lazy(() => import("src/modules/reports-analytics/report-builder/pages/target-builder"))
const PivotBuilder = lazy(() => import("src/modules/reports-analytics/report-builder/pages/pivot-builder"))
const AutomationsList = lazy(() => import("src/modules/reports-analytics/report-builder/pages/automations-list"))
const FlowBuilder = lazy(() => import("src/modules/reports-analytics/report-builder/pages/flow-builder"))

const reportAnalyticsRoutes = {
  path: "report-analytics",
  // ExportsHost now lives at the main-layout level (navbar entry point).
  children: [
    { index: true, element: <Navigate to="dashboards" /> },
    {
      path: "inventory-report",
      // Legacy permission on purpose: Inventory Report keeps the
      // original rows already attached to existing roles.
      element: (
        <PermissionRoute permission={"reporting-analytics:reports:read"}>
          <InventoryReport />
        </PermissionRoute>
      )
    },
    {
      path: "dashboards",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:read"}>
          <DashboardsList />
        </PermissionRoute>
      )
    },
    {
      path: "dashboards/:id",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:read"}>
          <DashboardView />
        </PermissionRoute>
      )
    },
    {
      path: "reports",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:read"}>
          <ReportsList />
        </PermissionRoute>
      )
    },
    {
      path: "automations",
      element: (
        <PermissionRoute permission={"reporting-analytics:automations:read"}>
          <AutomationsList />
        </PermissionRoute>
      )
    },
    {
      path: "automations/new",
      element: (
        <PermissionRoute permission={"reporting-analytics:automations:create"}>
          <FlowBuilder />
        </PermissionRoute>
      )
    },
    {
      path: "automations/:id/edit",
      // Read opens the flow read-only; Save/Test gate on update in-page.
      element: (
        <PermissionRoute permission={"reporting-analytics:automations:read"}>
          <FlowBuilder />
        </PermissionRoute>
      )
    },
    {
      path: "reports/new",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:create-report"}>
          <ReportBuilder />
        </PermissionRoute>
      )
    },
    {
      path: "reports/target/new",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:create-report"}>
          <TargetBuilder />
        </PermissionRoute>
      )
    },
    {
      path: "reports/target/:id/edit",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:create-report"}>
          <TargetBuilder />
        </PermissionRoute>
      )
    },
    {
      path: "reports/sql/new",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:create-sql"}>
          <SqlReport />
        </PermissionRoute>
      )
    },
    {
      path: "reports/sql/:id/edit",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:create-sql"}>
          <SqlReport />
        </PermissionRoute>
      )
    },
    {
      path: "reports/:id/pivot",
      // Pivots on visual sources save as reports (create-report); pivots on
      // SQL sources save via createSqlReport (create-sql) — either may enter,
      // the save mutation enforces the exact one.
      element: (
        <PermissionRoute
          permission={["reporting-analytics:analytics:create-report", "reporting-analytics:analytics:create-sql"]}
        >
          <PivotBuilder />
        </PermissionRoute>
      )
    },
    {
      path: "reports/:id",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:read"}>
          <ReportViewer />
        </PermissionRoute>
      )
    },
    {
      path: "reports/:id/edit",
      element: (
        <PermissionRoute permission={"reporting-analytics:analytics:create-report"}>
          <ReportBuilder />
        </PermissionRoute>
      )
    }
  ]
}

export default reportAnalyticsRoutes
